import { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import ImagesService from 'common/services/Images';

/**
 * Sections richfield d'un groupe, filtrées et triées.
 *
 * Reprend la logique de `common/components/RichFieldGroup` (filtre sur
 * `section.group`, tri des sections puis des champs par `order`) sans son
 * rendu : §6.4 du plan écarte les widgets `common` — `RichFieldImageList` ne
 * rend que des images, et `RichFieldNewsfeed` produit du HTML invalide, impose
 * ses niveaux de titre et n'expose ni `section.desc` ni le CTA de section.
 * Le contrat de données, lui, est conservé intégralement.
 *
 * Le filtrage par `appliesToReferences` et l'interpolation des variables
 * (`__PLACENAME__`, `__CITY__`, `__MERGE21__`…) sont déjà faits côté serveur
 * (`api_handler.js:413-416`) : on reçoit du prêt-à-afficher.
 *
 * Le hook est toujours appelé, jamais conditionnellement — commuter un bloc du
 * statique au richfield ne casse donc pas les règles des hooks.
 *
 * @param {string} group
 * @param {string} imageSize dérivé S3 demandé — `original | small | xsmall |
 *   thumbnail`, les seuls réellement produits à l'upload (liste blanche et
 *   repli documentés dans `common/services/Images`). `small` = 800 px de large,
 *   soit exactement le besoin de la galerie (760 px) et des vignettes. Le
 *   défaut était `medium`, une taille qui n'existe pas : invisible avec les
 *   images de test en chemin relatif, image cassée (403 S3) dès la première
 *   image uploadée depuis le BO.
 */
const useRichFields = (group, imageSize = 'small') => {
  const [state] = useContext(StateContext);
  const sections = (state.lp && state.lp.rich_fields) || [];

  return sections
    .filter((section) => section.group === group)
    .slice()
    .sort((a, b) => (parseInt(a.order, 10) < parseInt(b.order, 10) ? -1 : 1))
    .map((section) => {
      const fields = (section.fields || [])
        .slice()
        .sort((a, b) => (parseInt(a.order, 10) < parseInt(b.order, 10) ? -1 : 1));
      // srcSetRichFields renvoie une nouvelle section : le state n'est pas touché.
      return ImagesService.srcSetRichFields(imageSize, { ...section, fields });
    });
};

export default useRichFields;
